import { Camera, Matrix4, Vector3 } from 'three';

/**
 * Makes `camera.lookAt` take a point in the camera's parent space, the space
 * its position, `up` and the orbit target are in. Object3D.lookAt takes a
 * world point, which differs once the camera sits in a turned holder.
 */
export function lookAtInParentSpace(camera: Camera): void {
  const rotation = new Matrix4();
  const target = new Vector3();
  camera.lookAt = function (this: Camera, x: Vector3 | number, y?: number, z?: number): void {
    if (typeof x === 'number') target.set(x, y ?? 0, z ?? 0);
    else target.copy(x);
    rotation.lookAt(this.position, target, this.up);
    this.quaternion.setFromRotationMatrix(rotation);
  } as Camera['lookAt'];
}

/** The camera's line of sight in its parent space. */
export function viewForward(camera: Camera, target = new Vector3()): Vector3 {
  return target.set(0, 0, -1).applyQuaternion(camera.quaternion);
}
